export const MY_LEADS_TAB_KEYS = [
  "all",
  "daily-todo",
  "today-contacted",
  "past-due",
] as const;

export type MyLeadsTabKey = (typeof MY_LEADS_TAB_KEYS)[number];

const LABEL_TO_KEY: Record<string, MyLeadsTabKey> = {
  All: "all",
  "Daily To-do": "daily-todo",
  "Today Contacted": "today-contacted",
  "Past Due": "past-due",
};

const KEY_TO_LABEL: Record<MyLeadsTabKey, string> = {
  all: "All",
  "daily-todo": "Daily To-do",
  "today-contacted": "Today Contacted",
  "past-due": "Past Due",
};

export function myLeadsTabLabelToKey(label: string): MyLeadsTabKey {
  return LABEL_TO_KEY[label] ?? "all";
}

export function myLeadsTabKeyToLabel(key: MyLeadsTabKey): string {
  return KEY_TO_LABEL[key];
}

/** Maps UI tab label to API tab query value (lowercase, hyphenated). */
export function myLeadsTabLabelToApiValue(label: string): string {
  return myLeadsTabLabelToKey(label);
}

export function isMyLeadsTabKey(value: string): value is MyLeadsTabKey {
  return (MY_LEADS_TAB_KEYS as readonly string[]).includes(value);
}
